function i(r) {
  "@babel/helpers - typeof";
  return i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, i(r);
}
function u(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(r, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function a(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? u(Object(t), !0).forEach(function(n) {
      f(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : u(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function f(r, e, t) {
  return e = m(e), e in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
function m(r) {
  var e = g(r, "string");
  return i(e) === "symbol" ? e : String(e);
}
function g(r, e) {
  if (i(r) !== "object" || r === null) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (i(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
var O = function(e, t) {
  return [Object.keys(e), Object.keys(t)].reduce(function(n, o) {
    return n.filter(function(c) {
      return o.includes(c);
    });
  });
}, w = function(e) {
  return e;
}, d = function(e) {
  return e.replace(/([A-Z])/g, function(t) {
    return "-".concat(t.toLowerCase());
  });
}, j = function(e, t) {
  return Object.keys(t).reduce(function(n, o) {
    return a(a({}, n), {}, f({}, o, e(o, t[o])));
  }, {});
}, P = function(e, t, n) {
  return e.map(function(o) {
    return "".concat(d(o), " ").concat(t, "ms ").concat(n);
  }).join(",");
}, v = process.env.NODE_ENV !== "production", S = function(e, t, n, o, c, s, l, p) {
  if (v && typeof console < "u" && console.warn && (t === void 0 && console.warn("LogUtils requires an error message argument"), !e))
    if (t === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var y = [n, o, c, s, l, p], b = 0;
      console.warn(t.replace(/%s/g, function() {
        return y[b++];
      }));
    }
};
export {
  d as getDashCase,
  O as getIntersectionKeys,
  P as getTransitionVal,
  w as identity,
  j as mapObject,
  S as warn
};
